import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { MenyProductField } from '../../../common/enums/meny-product-field.enum';
import { takeUntil } from 'rxjs/operators';
import { FormCommonDataService } from '../../../common/services/form-common-data.service';
import { Subject } from 'rxjs';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { FormType } from '@sb-tools/typescript/enums/form-type.enum';
import { ClientField } from '../../../common/models/client-field.model';

@Component({
    selector: 'sb-meny-product-meta-field',
    templateUrl: './meny-product-meta-field.component.html',
    styleUrls: ['./meny-product-meta-field.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FormsModule],
})
export class MenyProductMetaFieldComponent implements OnInit, OnDestroy {
    @Input() formField: Field | ClientField;
    @Input() formType: FormType;
    @Input() metaFieldType: MenyProductField | string;

    isProductMetaDataHidden: boolean;
    isReadOnlyInput: boolean;

    private unsubscriber = new Subject<void>();

    constructor(private formCommonDataService: FormCommonDataService) {}

    ngOnInit() {
        this.isReadOnlyInput = this.formType !== FormType.inboxSearch;
        this.isProductMetaDataHidden = this.formType <= FormType.widgetAuthentication;

        this.formCommonDataService.menyProductUpdateSubject.pipe(takeUntil(this.unsubscriber)).subscribe((newValue) => {
            if (newValue) {
                this.formField.value = newValue[this.metaFieldType];
            } else {
                this.formField.value = null;
            }
        });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
